import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  icons: any = {};
  constructor() {
    import('@fortawesome/free-solid-svg-icons').then(
      (icons) => (this.icons = icons),
    );
  }

  getIcon(key: string) {
    return this.icons[key];
  }
}
